import { useReducer } from "react";
import { SfxAction, SfxData } from "../Sfx";
import { allSfx } from "../SfxDatas";

export const useSfxReducer = () => {
  const [data, dispatch] = useReducer(
    (data: SfxData, action: SfxAction) => {
      switch (action.type) {
        case "play":
          const audio = new Audio(allSfx[action.sfx]);
          audio.volume = data.isMuted ? 0 : 0.5;
          audio.play();
          //todo
          if ((window as any).rexelSounds === undefined)
            (window as any).rexelSounds = [];
          (window as any).rexelSounds.push(audio);
          return { ...data };
        case "loop":
          const loopAudio = new Audio(allSfx[action.sfx]);
          loopAudio.volume = data.isMuted ? 0 : 0.02;
          loopAudio.play();
          loopAudio.loop = true;
          if ((window as any).rexelSounds === undefined)
            (window as any).rexelSounds = [];
          (window as any).rexelSounds.push(loopAudio);
          return { ...data };
        case "setMute":
          (window as any).rexelSounds.forEach((el: any) => {
            el.volume = action.isMuted ? 0 : el.loop ? 0.02 : 0.5;
          });

          return { ...data, isMuted: action.isMuted };

        default:
          return { ...data };
      }
    },
    { isMuted: false }
  );

  return { data, dispatch };
};
